export function buildClientSecretName(): string {
  const currentDate: Date = new Date();
  const secretName: string = new Date(
    currentDate.getFullYear() + 2,
    currentDate.getMonth(),
    currentDate.getDate()
  )
    .toLocaleDateString()
    .replaceAll('/', '-');

  return secretName;
}

export function computeDaysToExpire(expirationDate: Date | string): number {
  const currentDate: Date = new Date();
  const expiration: Date = new Date(expirationDate);
  const timeDifference: number = expiration.getTime() - currentDate.getTime();
  const daysToExpire: number = Math.ceil(timeDifference / (1000 * 3600 * 24));

  return daysToExpire;
}

export function getSecretExpiryStatus(expirationDate: Date | string): {
  color: string;
  label: string;
} {
  const daysToExpire: number = computeDaysToExpire(expirationDate);

  if (daysToExpire < 0) {
    return { color: 'aw-dark-gray-1000', label: 'Expired' };
  } else if (daysToExpire <= 15) {
    return { color: 'aw-warning-1000', label: 'Expiring' };
  } else {
    return { color: 'success-green-700', label: 'Active' };
  }
}
